import { createBrowserRouter, Navigate } from 'react-router';

import { DestinoInicial } from '@/features/acoes/DestinoInicial';
import { GavetaDaAcao } from '@/features/acoes/GavetaDaAcao';
import { GavetaDeNovaAcao } from '@/features/acoes/GavetaDeNovaAcao';
import { PaginaDeAcoes } from '@/features/acoes/PaginaDeAcoes';
import { paineis } from '@/features/acoes/paineis';
import { PaginaDeLogin } from '@/features/autenticacao/PaginaDeLogin';
import { PaginaDeTrocaDeSenha } from '@/features/autenticacao/PaginaDeTrocaDeSenha';
import { RotaProtegida } from '@/features/autenticacao/RotaProtegida';
import { LayoutDeCadastros } from '@/features/cadastros/LayoutDeCadastros';
import { PaginaDeAreas } from '@/features/cadastros/PaginaDeAreas';
import { PaginaDeClientes } from '@/features/cadastros/PaginaDeClientes';
import { PaginaDeUsuarios } from '@/features/cadastros/PaginaDeUsuarios';
import { PaginaDeDiagnostico } from '@/features/diagnostico/PaginaDeDiagnostico';
import { PaginaDeTokens } from '@/features/showcase/PaginaDeTokens';
import { LayoutPrincipal } from '@/layouts/LayoutPrincipal';

/**
 * Rotas da aplicacao. Especificacao V3.1, item 12.3.
 *
 * /login e a unica rota publica. Todo o resto exige sessao, espelhando a politica de
 * fallback do servidor, que nega por padrao o que nao declara AllowAnonymous.
 *
 * A troca de senha fica FORA do layout principal: e tela de credencial, e mostrar a
 * navegacao da aplicacao ao lado convidaria a escapar de uma troca que o servidor
 * considera obrigatoria.
 *
 * AS ROTAS DE ADMINISTRACAO NAO SAO PROTEGIDAS AQUI. O servidor recusa com 403 quem nao
 * tem a permissao, e e ele quem decide. O que o cliente faz e nao desenhar o link — ver
 * LayoutPrincipal. Esconder link e desenho de interface, nao seguranca.
 */
export const roteador = createBrowserRouter([
  { path: '/login', element: <PaginaDeLogin /> },

  {
    element: <RotaProtegida />,
    children: [
      { path: '/trocar-senha', element: <PaginaDeTrocaDeSenha /> },

      {
        path: '/',
        element: <LayoutPrincipal />,
        children: [
          { index: true, element: <DestinoInicial /> },
          /*
            CRIACAO E DETALHE SAO FILHAS DE 'acoes', e nao irmas.

            As duas acontecem em gaveta sobre a lista, e a lista precisa continuar montada
            atras. Como rotas irmas, entrar em /acoes/3 desmontaria a tabela, e voltar
            refaria a consulta e perderia filtro e pagina.

            /acoes/nova e /acoes/3 continuam sendo URLs de verdade: F5 e link compartilhado
            reabrem a gaveta sobre a lista.

            'nova' antes de ':id' por leitura. O ranqueamento do React Router ja prefere
            segmento estatico a dinamico.
          */
          /*
            DOIS PAINEIS, UMA TELA.

            /acoes atende o Painel CS e /fila atende o Painel Produto, com a mesma
            PaginaDeAcoes recebendo o recorte. As gavetas sao filhas das duas, porque abrir
            uma acao a partir da fila tem de devolver a pessoa para a fila.

            /acoes continua sendo o endereco do CS, e nao /painel/cs, porque e o endereco
            que ja esta em uso — trocar invalidaria os links de acao que alguem tenha
            guardado, e o caminho de uma acao e /acoes/3.

            O `key` NAO E DECORACAO. Sem ele, React reconcilia os dois elementos pelo tipo,
            o componente nao remonta na troca de aba e o filtro de situacao atravessa: quem
            filtrasse por Rascunho no CS e fosse para a fila veria tabela vazia, porque
            Rascunho nao existe naquele recorte.
          */
          {
            path: 'acoes',
            element: <PaginaDeAcoes key="painel-cs" painel={paineis.Cs} />,
            children: [
              { path: 'nova', element: <GavetaDeNovaAcao /> },
              { path: ':id', element: <GavetaDaAcao /> },
            ],
          },
          {
            path: 'fila',
            element: <PaginaDeAcoes key="painel-produto" painel={paineis.Produto} />,
            children: [
              { path: 'nova', element: <GavetaDeNovaAcao /> },
              { path: ':id', element: <GavetaDaAcao /> },
            ],
          },
          /*
            Cadastros virou uma area com abas, em vez de tres links no topo.

            Os tres eram de primeiro nivel ao lado dos paineis, disputando espaco com o
            trabalho do dia. Cadastro e operacao ocasional de administrador.

            AS ROTAS CONTINUAM NAO PROTEGIDAS AQUI, pela mesma razao do comentario no
            inicio do arquivo: o servidor recusa com 403, e e ele quem decide.
          */
          {
            path: 'cadastros',
            element: <LayoutDeCadastros />,
            children: [
              { index: true, element: <Navigate to="areas" replace /> },
              { path: 'areas', element: <PaginaDeAreas /> },
              { path: 'clientes', element: <PaginaDeClientes /> },
              { path: 'usuarios', element: <PaginaDeUsuarios /> },
            ],
          },

          // Enderecos antigos. Alguem pode ter guardado /usuarios nos favoritos, e um 404
          // faria parecer que a tela foi removida.
          { path: 'areas', element: <Navigate to="/cadastros/areas" replace /> },
          { path: 'clientes', element: <Navigate to="/cadastros/clientes" replace /> },
          { path: 'usuarios', element: <Navigate to="/cadastros/usuarios" replace /> },
          { path: 'diagnostico', element: <PaginaDeDiagnostico /> },
          { path: 'tokens', element: <PaginaDeTokens /> },
        ],
      },
    ],
  },
]);
